import { render, staticRenderFns } from "./MypageInventoryDetails.vue?vue&type=template&id=b30bd07a&scoped=true&"
import script from "./MypageInventoryDetails.vue?vue&type=script&lang=js&"
export * from "./MypageInventoryDetails.vue?vue&type=script&lang=js&"
import style0 from "./MypageInventoryDetails.vue?vue&type=style&index=0&id=b30bd07a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b30bd07a",
  null
  
)

export default component.exports